import * as $ from "jquery";
import * as ko from 'knockout';
import * as _ from 'underscore';
import {GenericDeserialize} from 'libs/cerialize';

import {MenuManager} from 'MenuManager/MenuManager';
import {ScreenTypes} from 'Core/Common/Enums/ScreenTypes';
import {ScreenModel} from 'Core/Models/Screens/ScreenModel';
import {FormProperties} from 'Core/Screens/DesignScreen/Models/FormProperties';
import {FlowFolderPopover, FlowFolderPopoverOptions} from "Core/Components/FlowFolderPopover/FlowFolderPopover";

import CardScreenTemplate
    from 'Core/Screens/Templates/AdditionalConsultScreen/CardScreen/CardScreen.html';

import { ConsultScreen } from "Core/Screens/ConsultScreen/ConsultScreen";

import {getWidthValue} from "Core/Screens/CardScreen/CardScreenUtils";
import {CARD_SCREEN_PROPERTY_TYPE} from "../../Constant";
import {ISettingsModal} from "../../Controls/FormDesigner/SettingsModal/SettingsModal";
import {PUB_SUB_EVENTS} from "MenuManager/PubSubEvents";

ko.templates['Core/Screens/Templates/AdditionalConsultScreen/CardScreen/CardScreen'] = CardScreenTemplate;

export class CardScreen extends ConsultScreen {
    private _properties: FormProperties = {};

    private _hasCustomColor: KnockoutObservable<boolean>;
    private _hasCustomWeight: KnockoutObservable<boolean>;
    private _screenWidth: KnockoutObservable<any>;
    private _screenBgColor: KnockoutObservable<any>;
    private _screenColors: KnockoutObservable<any>;
    private _fontColor: KnockoutObservable<any>;
    private _customStyle: KnockoutObservable<any>;

    private _fontFamily: KnockoutObservable<string>;
    private _fontWeight: KnockoutObservable<string>;
    private _fontStyle: KnockoutObservable<string>;
    private _flowFolderPopover: FlowFolderPopover;

    constructor(screenModel: ScreenModel) {
        super(screenModel);

        this._hasCustomColor = ko.observable(null);
        this._hasCustomWeight = ko.observable(null);
        this._screenWidth = ko.observable(null);
        this._screenBgColor = ko.observable(null);
        this._screenColors = ko.observable(null);
        this._fontColor = ko.observable(null);
        this._customStyle = ko.observable(null);

        this._fontFamily = ko.observable(null);
        this._fontWeight = ko.observable(null);
        this._fontStyle = ko.observable(null);

        try {
            this._properties = GenericDeserialize(JSON.parse(screenModel.Properties), FormProperties);
        } catch (error) {}
        
        this._flowFolderPopover = new FlowFolderPopover();
    }

    GetTemplateName() {
        return 'Core/Screens/Templates/AdditionalConsultScreen/CardScreen/CardScreen';
    }

    AfterRender(el: HTMLElement[]) {
        super.AfterRender(el);
        this._el = el[0]

        const bgColor = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.SCREEN_BACKGROUND_COLOR)?.Value,
            screenWidth = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.SCREEN_WIDTH)?.Value,
            fontColor = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.FONT_COLOR)?.Value,
            fontFamily = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.FONT_FAMILY)?.Value.Value,
            fontWeight = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.FONT_WEIGHT)?.Value.Value,
            fontStyle = this.FindElementByType(this._properties?.Options, CARD_SCREEN_PROPERTY_TYPE.FONT_STYLE)?.Value.Value;

        this._screenWidth(!!screenWidth?.Value ? `calc(${getWidthValue(screenWidth)} - 5px)` : null);
        this._screenBgColor(!!bgColor ? bgColor : null);
        this._fontColor(!!fontColor ? fontColor : null);

        this._fontFamily(!!fontFamily ? fontFamily : null);
        this._fontWeight(!!fontWeight ? fontWeight : null);
        this._fontStyle(!!fontStyle ? fontStyle : null);

        this._customStyle(`${this._fontFamily()} ${this._fontWeight()} ${this._fontStyle()}`);
        this._hasCustomWeight(!!this._fontWeight());
        this._hasCustomColor(!!this._fontColor());
        
        const openedTypeFlowFolder = MenuManager.Instance.GetOpenedTypeFlowFolder();
        
        if (this.GetRecordId() > 0 && openedTypeFlowFolder && (this.SourceScreen && this.SourceScreen !== ScreenTypes[ScreenTypes.EditScreen])){
            setTimeout(() => {
                const $el: any = $($(el).closest('.row'));
                const gridContainer = $el.closest('.grid-relative-container');
                
                const resizeObserver = new ResizeObserver(() => {
                    let options: FlowFolderPopoverOptions = {
                        EntityId: this.GetEntityId(),
                        RecordId: this.GetRecordId(),
                        PopoverOptions: {
                            Element: $el,
                            Container: gridContainer,
                            Viewport: gridContainer,
                            Placement: 'left',
                            Trigger: 'manual',
                            CustomTemplateClass: 'grid-relative-container__flow-folder-popover card-screen__flow-folder-popover'
                        },
                        IsCardScreen: true
                    }
                    this._flowFolderPopover.Init(options);
                })

                if (gridContainer[0]) {
                    resizeObserver.observe(gridContainer[0]);
                }
                
                ko.utils.domNodeDisposal.addDisposeCallback($el[0], () => {
                    this._flowFolderPopover.Destroy($el);
                    resizeObserver.unobserve(gridContainer[0]);
                });
            }, 1500);
        }
    }

    FlowFolderPopoverDestroy(element: HTMLElement): void {
        this._flowFolderPopover.Destroy(element);
    }

    FlowFolderPopoverShow(element: HTMLElement): void {
        this._flowFolderPopover.Show(element);
    }

    FindElementByType(array: ISettingsModal[], type: string): ISettingsModal | undefined {
        return _.find(array, { Type: type });
    }
}